import { createContext, Dispatch, SetStateAction } from 'react';

interface AppCtx {
  appContextState: string;
  setAppContextState: Dispatch<SetStateAction<AppCtx['appContextState']>>;
}

// App Context controls the 3 modes of
// the app - normal, timeMachine, superUser
const AppContext = createContext({
  appContextState: 'normal',
  setAppContextState: () => 'normal',
} as AppCtx);

export default AppContext;
